/*
  Buchanan Albert header search (step 8). The search icon in the header opens this light
  search sheet instead of the stock search window. Typing shows the first matching pieces at
  once (same everyday-word search as the shop pages, assets/ba-find.js, loaded on first open);
  Search or "See all" opens All products with the search applied (/collections/all#q=...).
  Loaded by snippets/ba-header-nav.liquid; data-find on the script tag names ba-find.js.
*/
(() => {
  if (window.__dcSearch) return;
  window.__dcSearch = true;
  const me = document.currentScript;
  const FIND_SRC = me && me.dataset.find;
  const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const ALL = ROOT + 'collections/all';
  const POPULAR = ['Coats', 'Knitwear', 'Boots', 'Maxi dress', 'Blazer', 'Loafers'];
  const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
  let dlg = null;
  let input = null;
  let list = null;
  let asked = false;
  let timer = 0;
  let seq = 0;

  const go = (q) => {
    const url = ALL + (q ? '#q=' + encodeURIComponent(q) : '');
    const here = location.pathname === ALL && document.querySelector('[data-ba-find]');
    if (here && here.baFinder) {
      /* already on All products: search right here */
      close();
      const f = here.baFinder;
      f.input.value = q;
      f.state = Object.assign(f.blank(), { q });
      f.load().then(() => {
        f.apply();
        f.scrollToResults();
      });
    } else location.href = url;
  };
  const needFind = () => {
    if (window.BAFind || asked || !FIND_SRC) return;
    asked = true;
    const s = document.createElement('script');
    s.src = FIND_SRC;
    s.onload = () => window.BAFind && window.BAFind.load().then(show, () => {});
    document.head.appendChild(s);
  };
  const CSS = `
    .ba-qs { position: fixed; inset: 0 0 auto 0; width: 100%; max-width: 100%; max-height: 92vh; margin: 0; padding: 0; border: 0; background: #FFFFFF; color: #16291F; font-family: 'Instrument Sans', system-ui, -apple-system, sans-serif; overflow: auto; }
    .ba-qs[open] { animation: ba-qs-in 0.2s ease-out; }
    @keyframes ba-qs-in { from { transform: translateY(-12px); opacity: 0; } to { transform: none; opacity: 1; } }
    .ba-qs::backdrop { background: rgba(22, 41, 31, 0.45); }
    .ba-qs * { box-sizing: border-box; }
    .ba-qs__in { max-width: 720px; margin: 0 auto; padding: 12px 16px 20px; }
    .ba-qs__row { display: flex; gap: 8px; align-items: center; }
    .ba-qs__form { position: relative; flex: 1 1 auto; margin: 0; }
    .ba-qs__icon { position: absolute; left: 14px; top: 50%; width: 18px; height: 18px; transform: translateY(-50%); color: rgba(22, 41, 31, 0.55); pointer-events: none; }
    .ba-qs__input { display: block; width: 100%; height: 50px; margin: 0; padding: 0 12px 0 42px; border: 1px solid #1E3A2C; border-radius: 0; background: #FFFFFF; font: 16px 'Instrument Sans', system-ui, sans-serif; color: #16291F; -webkit-appearance: none; appearance: none; outline: none; }
    .ba-qs__input::-webkit-search-cancel-button { display: none; }
    .ba-qs__close { flex: none; width: 48px; height: 50px; padding: 0; border: 0; background: transparent; color: #16291F; font: 500 14px 'Instrument Sans', system-ui, sans-serif; cursor: pointer; }
    .ba-qs__body { padding-top: 16px; }
    .ba-qs__body > :first-child { margin-top: 0 !important; }
    .ba-qs__label { margin: 18px 0 10px; font-size: 12px; font-weight: 500; letter-spacing: 0.18em; text-transform: uppercase; color: #1E3A2C; }
    .ba-qs__chips { display: flex; flex-wrap: wrap; gap: 8px; margin: 0; padding: 0; list-style: none; }
    .ba-qs__chip { display: inline-flex; align-items: center; min-height: 44px; padding: 0 14px; border: 1px solid #DAD3C6; background: #FFFFFF; color: #16291F; font-size: 14px; text-decoration: none; cursor: pointer; }
    .ba-qs__list { margin: 6px 0 0; padding: 0; list-style: none; }
    .ba-qs__item a { display: grid; grid-template-columns: 56px 1fr; gap: 12px; align-items: center; min-height: 68px; padding: 6px 0; border-bottom: 1px solid #DAD3C6; color: inherit; text-decoration: none; }
    .ba-qs__thumb { width: 56px; height: 56px; object-fit: cover; background: #F4EFE6; display: block; }
    .ba-qs__t { display: block; font-size: 14px; line-height: 1.35; }
    .ba-qs__p { display: block; margin-top: 2px; font-size: 13px; font-weight: 500; }
    .ba-qs__p s { margin-left: 6px; font-weight: 400; color: rgba(22, 41, 31, 0.5); }
    .ba-qs__all { display: flex; align-items: center; justify-content: center; width: 100%; min-height: 50px; margin-top: 14px; border: 1px solid #1E3A2C; background: #1E3A2C; color: #FFFFFF; font: 500 15px 'Instrument Sans', system-ui, sans-serif; cursor: pointer; }
    .ba-qs__hint { margin: 14px 0 0; font-size: 14px; line-height: 1.5; color: rgba(22, 41, 31, 0.75); }
    html.ba-qs-lock, html.ba-qs-lock body { overflow: hidden; }
  `;
  const build = () => {
    if (dlg) return;
    const st = document.createElement('style');
    st.textContent = CSS;
    document.head.appendChild(st);
    dlg = document.createElement('dialog');
    dlg.className = 'ba-qs';
    dlg.setAttribute('aria-label', 'Search the shop');
    dlg.innerHTML =
      '<div class="ba-qs__in"><div class="ba-qs__row">' +
      '<form class="ba-qs__form" role="search" action="' + esc(ALL) + '" method="get">' +
      '<label class="ba-qs__label" style="position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);margin:-1px" for="ba-qs-q">Search the shop</label>' +
      '<svg class="ba-qs__icon" viewBox="0 0 20 20" aria-hidden="true"><circle cx="8.5" cy="8.5" r="6" fill="none" stroke="currentColor" stroke-width="1.6"/><path d="M13 13l5 5" stroke="currentColor" stroke-width="1.6"/></svg>' +
      '<input class="ba-qs__input" id="ba-qs-q" type="search" name="q" placeholder="Dresses, linen, loafers" autocomplete="off" autocapitalize="off" spellcheck="false" enterkeyhint="search"></form>' +
      '<button type="button" class="ba-qs__close" data-qs-close>Close</button></div>' +
      '<div class="ba-qs__body" data-qs-body></div></div>';
    document.body.appendChild(dlg);
    input = dlg.querySelector('input');
    list = dlg.querySelector('[data-qs-body]');
    dlg.querySelector('form').addEventListener('submit', (e) => {
      e.preventDefault();
      go(input.value.trim());
    });
    input.addEventListener('input', () => {
      clearTimeout(timer);
      timer = setTimeout(show, 140);
    });
    dlg.addEventListener('click', (e) => {
      if (e.target === dlg || e.target.closest('[data-qs-close]')) close();
      const t = e.target.closest('[data-qs-try]');
      if (t) {
        input.value = t.dataset.qsTry;
        show();
        input.focus();
      }
      if (e.target.closest('[data-qs-all]')) go(input.value.trim());
    });
    dlg.addEventListener('close', () => document.documentElement.classList.remove('ba-qs-lock'));
    window.addEventListener('pageshow', (e) => {
      if (e.persisted && dlg.open) close();
    });
  };
  const popular = () =>
    '<p class="ba-qs__label">Popular</p><ul class="ba-qs__chips" role="list">' +
    POPULAR.map((t) => '<li><button type="button" class="ba-qs__chip" data-qs-try="' + esc(t) + '">' + esc(t) + '</button></li>').join('') +
    '</ul>';
  const show = async () => {
    if (!list) return;
    const q = input.value.trim();
    const my = ++seq;
    if (!q) {
      list.innerHTML = popular();
      return;
    }
    if (!window.BAFind) {
      list.innerHTML = '<button type="button" class="ba-qs__all" data-qs-all>Search for “' + esc(q) + '”</button>';
      return;
    }
    let r;
    const slow = setTimeout(() => {
      if (my === seq) list.innerHTML = '<p class="ba-qs__hint">Searching...</p><button type="button" class="ba-qs__all" data-qs-all>Search for “' + esc(q) + '”</button>';
    }, 250);
    try {
      r = await window.BAFind.suggest(q, 5);
    } catch (e) {
      r = null;
    }
    clearTimeout(slow);
    if (my !== seq) return;
    if (!r || !r.items.length) {
      list.innerHTML =
        '<p class="ba-qs__hint">Nothing called “' + esc(q) + '” yet. Try one of these, or search the whole shop.</p>' +
        popular() + '<button type="button" class="ba-qs__all" data-qs-all>Search the shop</button>';
      return;
    }
    list.innerHTML =
      (r.fixed ? '<p class="ba-qs__hint">Showing results for “' + esc(r.fixed) + '”.</p>' : '') +
      '<ul class="ba-qs__list" role="list">' +
      r.items
        .map(
          (p) =>
            '<li class="ba-qs__item"><a href="' + esc(p.url) + '">' +
            (p.img ? '<img class="ba-qs__thumb" src="' + esc(p.img) + '" alt="" width="56" height="56" loading="eager">' : '<span class="ba-qs__thumb"></span>') +
            '<span><span class="ba-qs__t">' + esc(p.title) + '</span><span class="ba-qs__p">' + esc(p.price) + (p.was ? '<s>' + esc(p.was) + '</s>' : '') + '</span></span></a></li>'
        )
        .join('') +
      '</ul><button type="button" class="ba-qs__all" data-qs-all>See all ' + r.total + (r.total === 1 ? ' piece' : ' pieces') + '</button>';
  };
  const open = () => {
    build();
    document.documentElement.classList.add('ba-qs-lock');
    dlg.showModal();
    input.focus(); // inside the tap, so the iPhone keyboard opens at once
    show();
    needFind();
  };
  const close = () => {
    if (dlg && dlg.open) dlg.close();
    document.documentElement.classList.remove('ba-qs-lock');
  };
  /* Take over the header search icon. Listen on window in the capture phase: it runs before the theme's own
     on:click handler on document (which otherwise also opened the stock search window under this one). */
  const closeStock = () => {
    document.querySelectorAll('dialog.search-modal__content[open], .search-modal dialog[open]').forEach((d) => {
      try { d.close(); } catch (err) { d.removeAttribute('open'); }
    });
  };
  window.addEventListener(
    'click',
    (e) => {
      const b = e.target.closest && e.target.closest('.search-modal__button');
      if (!b || typeof HTMLDialogElement !== 'function') return;
      e.preventDefault();
      e.stopImmediatePropagation();
      open();
      closeStock();
      requestAnimationFrame(closeStock); // belt and braces if the stock window still opens
    },
    true
  );
  const warm = (e) => {
    if (e.target.closest && e.target.closest('.search-modal__button')) needFind();
  };
  ['pointerover', 'touchstart', 'focusin'].forEach((t) => window.addEventListener(t, warm, { passive: true, capture: true }));
  /* A tap held by the early catcher in layout/theme.liquid (page still loading): open now. */
  if (window.__baSearchQ) {
    window.__baSearchQ = 0;
    open();
    closeStock();
  }
})();
